import request from "@/utils/request";

export function validateEMail(rule, value, callback) {
  const reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱'));
    } else {
      callback();
    }
  }
}

/**
 * 手机号
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validatePhone(rule, value, callback) {
  const reg = /^[1][3-9][0-9]{9}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}

export function validateNum(rule, value, callback) {
  const reg =/^0{1}(\.\d*)|(^[1-9][0-9]*)+(\.\d*)?$/
  if ((!reg.test(value)) && value != '') {
    callback(new Error('请输入数字格式'));
  }else{
    callback()
  }
}

/* 是否身份证号码,内招专用*/
export function validatedNo(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的身份证号码'));
    } else {
      //调sap检查身份证号
      request({
        url: "/sap/bc/zhr/zhr",
        method: "get",
        params: {
          method: "hr-icnum",
          icnum: value
        }
      }).then(response => {
        if (response.data.flag) {
          //flag: true, message: "验证成功",不存在
          callback();
        } else {
          //{flag: false, message: "已是五粮液员工"}
          callback(new Error('已是五粮液员工，请通过内部招聘提交申请。'));

        }
      });
    }
  }
}

/* 是否身份证号码,内招专用*/
export function validatedNo2(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的身份证号码'));
    } else {
      callback()
    }
  }
}


/* 是否身份证号码,并去sap检查身份证是否存在*/
export function validatedNo_internal(rule, value, callback) {

  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的身份证号码'));
    } else {

      //调sap检查身份证号
      request({
        url: "/sap/bc/zhr/zhr",
        method: "get",
        params: {
          method: "hr-icnum",
          icnum: value
        }
      }).then(response => {
        if (response.data.flag) {
          //flag: true, message: "验证成功",不存在
          callback();
        } else {
          //{flag: false, message: "已是五粮液员工"}
          callback(new Error('已有EHR工号，只能通过选择【是否有工号-有】查询系统信息的方式提交材料！'));
        }
      });
    }
  }
}

//监听lo
export function dispatchEventStroage() {
  const signSetItem = sessionStorage.setItem
  sessionStorage.setItem = function (key, val) {
    let setEvent = new Event('setItemEvent')
    setEvent.key = key
    setEvent.newValue = val
    window.dispatchEvent(setEvent)
    signSetItem.apply(this, arguments)
  }
}





// WEBPACK FOOTER //
// ./src/utils/validate.js